export const LANGUAGE_SHAPES_BACKGROUND_IMAGES: Record<string, { default: string } | undefined> = {
  ar: require('images/language-shapes/ar.png'),
  cy: require('images/language-shapes/cy.png'),
  da: require('images/language-shapes/da.png'),
  de: require('images/language-shapes/de.png'),
  el: require('images/language-shapes/el.png'),
  en: require('images/language-shapes/en.png'),
  'en-us': require('images/language-shapes/en-us.png'),
  es: require('images/language-shapes/es.png'),
  'es-mx': require('images/language-shapes/es-mx.png'),
  fa: require('images/language-shapes/fa.png'),
  fr: require('images/language-shapes/fr.png'),
  gl: require('images/language-shapes/gl.png'),
  ha: require('images/language-shapes/ha.png'),
  he: require('images/language-shapes/he.png'),
  hi: require('images/language-shapes/hi.png'),
  id: require('images/language-shapes/id.png'),
  ig: require('images/language-shapes/ig.png'),
  is: require('images/language-shapes/is.png'),
  it: require('images/language-shapes/it.png'),
  'jp-full': require('images/language-shapes/jp.png'),
  'jp-romaji': require('images/language-shapes/jp.png'),
  kn: require('images/language-shapes/kn.png'),
  ko: require('images/language-shapes/ko.png'),
  mn: require('images/language-shapes/mn.png'),
  nl: require('images/language-shapes/nl.png'),
  no: require('images/language-shapes/no.png'),
  pl: require('images/language-shapes/pl.png'),
  pt: require('images/language-shapes/pt.png'),
  'pr-br': require('images/language-shapes/pt-br.png'),
  ru: require('images/language-shapes/ru.png'),
  sl: require('images/language-shapes/sl.png'),
  so: require('images/language-shapes/so.png'),
  sv: require('images/language-shapes/sv.png'),
  sw: require('images/language-shapes/sw.png'),
  ta: require('images/language-shapes/ta.png'),
  te: require('images/language-shapes/te.png'),
  th: require('images/language-shapes/th.png'),
  tl: require('images/language-shapes/tl.png'),
  tr: require('images/language-shapes/tr.png'),
  uk: require('images/language-shapes/uk.png'),
  ur: require('images/language-shapes/ur.png'),
  vi: require('images/language-shapes/vi.png'),
  xh: require('images/language-shapes/xh.png'),
  yo: require('images/language-shapes/yo.png'),
  'zh-cn': require('images/language-shapes/zh-cn.png'),
};
